import { useEffect, useRef, useState } from "react";
import L from "leaflet";
import { Box, Typography } from "@mui/material";
import BottomSheetLayout from "../../../../../../../components/BottomSheetLayout";
import CustomButton from "../../../../../../../components/CustomButton";
import { useAppSelector } from "../../../../../../../../hooks/useRedux";

interface Props {
  open: boolean;
  onDismiss: () => void;
  getAddress: (addres: string) => void;
  center?: { lat: number; lng: number } | null;
}

const NAV_APPS = [
  {
    label: "نشان",
    color: "#2196F3",
    href: (lat: number, lng: number) =>
      `https://nshn.ir?destination=${lat},${lng}&vehicle=d`,
  },
  {
    label: "گوگل مپ",
    color: "#34A853",
    href: (lat: number, lng: number) =>
      `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`,
  },
  {
    label: "ویز",
    color: "#6C3CE1",
    href: (lat: number, lng: number) =>
      `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`,
  },
];

function MapBoxBottomSheet(props: Props) {
  const { open, onDismiss, center } = props;

  const themeMode = useAppSelector((state) => state.settings.themeMode);

  const [mapContainer, setMapContainer] = useState<HTMLElement | null>();
  const L = (window as any).L;
  const mapRef = useRef<any>(null);

  const onMoveEnd = async () => {
    var bounds = mapRef.current.getBounds();
    var lat = (bounds._northEast.lat + bounds._southWest.lat) / 2;
    var long = (bounds._northEast.lng + bounds._southWest.lng) / 2;
  };

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setMapContainer(document.getElementById("map"));
      }, 100);
    } else {
      mapRef.current = null;
    }
  }, [open]);

  useEffect(() => {
    if (!mapRef.current) {
      if (mapContainer) {
        const mapCenter: [number, number] =
          center?.lat && center?.lng
            ? [center.lat, center.lng]
            : [35.7223845, 51.3717214];

        mapRef.current = new L.Map("map", {
          key: "web.1d5f93475eea4ab18d8eedcbe3f8cb80",
          maptype: themeMode === "dark" ? "standard-night" : "standard-day",
          poi: false,
          traffic: false,
          center: mapCenter,
          zoom: center?.lat && center?.lng ? 15 : 13,
        });

        if (center?.lat && center?.lng) {
          L.marker([center.lat, center.lng]).addTo(mapRef.current);
        }

        setTimeout(() => mapRef.current?.invalidateSize(), 300);
        mapRef.current.on("moveend", onMoveEnd);
      }
    }
  }, [mapContainer]);

  useEffect(() => {
    onDismiss();
  }, [themeMode]);

  return (
    <>
      <BottomSheetLayout height="100%" open={open} onDismiss={onDismiss}>
        <div
          id="map"
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
          }}
        >
          <Box
            sx={{
              zIndex: 9999999999,
              position: "absolute",
              bottom: "6px",
              left: "6px",
              right: "12px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            {center?.lat && center?.lng && (
              <Box
                sx={{
                  display: "flex",
                  gap: "8px",
                }}
              >
                {NAV_APPS.map((app) => (
                  <Box
                    key={app.label}
                    component="a"
                    href={app.href(center.lat, center.lng)}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "4px",
                      backgroundColor: app.color,
                      borderRadius: "10px",
                      padding: "10px 6px",
                      textDecoration: "none",
                      boxShadow: "0px 2px 6px rgba(0,0,0,0.25)",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: "13px",
                        fontWeight: "700",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {app.label}
                    </Typography>
                    <Typography
                      sx={{
                        color: "rgba(255,255,255,0.85)",
                        fontSize: "10px",
                      }}
                    >
                      مسیریابی
                    </Typography>
                  </Box>
                ))}
              </Box>
            )}

            <CustomButton
              onClick={() => onDismiss()}
              flex={1}
              width="100%"
              flexDirection="row"
              title="بستن"
              justifyContent="center"
              bgColor="primary.main"
              fSize="18px"
              fWeight="700"
              px="10px"
              py="10px"
              borderRadius="10px"
            />
          </Box>
        </div>
      </BottomSheetLayout>
    </>
  );
}

export default MapBoxBottomSheet;
